import { trim } from './string'

type DataObject = {
  [index: string]: string | number | null | boolean
}

const trimObjectValues = (data: Record<string, string>) => {
  let creating = {}
  Object.keys(data).forEach((key: string) => {
    creating = { ...creating, [key]: trim(data[key]) }
    return data[key]
  })
  return creating
}

const validationIsValid = (data: object) => Object.values(data).every((x) => x === '')

const isObjectEmpty = (data: object) => Object.keys(data).length === 0

const adjustEmptyValuesObject = (data: DataObject) => {
  const validData = { ...data }
  Object.keys(data).forEach((key: string) => (data[key] === null ? (validData[key] = '') : null))
  return validData
}

const toBase64 = (file: Blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })

const base64toFile = (data: string, filename: string) => {
  const fileData = Uint8Array.from(window.atob(data), (c) => c.charCodeAt(0))
  return new File([fileData], filename)
}

export {
  adjustEmptyValuesObject,
  base64toFile,
  isObjectEmpty,
  toBase64,
  trimObjectValues,
  validationIsValid,
}
